import { API } from "../../types";

type Data = {
  hour12: boolean;
  mode: "analogue" | "digital";
  showDate: boolean;
  showMinutes: boolean;
  showSeconds: boolean;
  showDayPeriod?: boolean;
  timeZone: string | null;
  name?: string;
  showTime?: boolean;
};

export type Props = API<Data>;

export const defaultData: Data = {
  mode: "digital",
  hour12: true,
  showDate: true,
  showMinutes: true,
  showSeconds: true,
  showDayPeriod: true,
  timeZone: null,
  showTime: true,
};
